import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100 bcl-token-list-table" }
const _hoisted_2 = { class: "cell cell-rank text-body-2 opacity-50 text-left py-1 pl-2 pl-md-4" }
const _hoisted_3 = { class: "cell cell-name text-body-2 opacity-50 text-left py-1 px-3" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 0,
  class: "cell cell-collection text-body-2 opacity-50 text-left text-md-right py-1 px-3"
}
const _hoisted_6 = { class: "cell cell-price text-body-2 opacity-50 text-left text-md-right py-1 px-3" }
const _hoisted_7 = { class: "cell cell-market-cap text-body-2 opacity-50 text-right py-1 px-3" }
const _hoisted_8 = { class: "cell cell-address text-body-2 opacity-50 text-right py-1 px-3" }
const _hoisted_9 = { class: "cell cell-chart text-body-2 opacity-50 text-right py-1 pl-3" }
const _hoisted_10 = {
  key: 0,
  class: "token-list-skeleton"
}
const _hoisted_11 = { key: 1 }

import { computed } from "vue";

import { useCommunityFactory } from "@/composables";

import TokenListTableRow from "./TokenListTableRow.vue";
import AppTooltip from "@/components/Common/AppTooltip.vue";
import TokenRowSkeleton from "@/components/Skeletons/TokenList/TokenRowSkeleton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TokenListTable',
  props: {
  pages: { type: Array, default: null },
  loading: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;

const { activeFactoryCollectionsNum } = useCommunityFactory();

const showCollectionColumn = computed(
  () => activeFactoryCollectionsNum.value > 1
);

const allItems = computed(() =>
  props.pages?.length ? props.pages.map((page) => page.items).flat() : []
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _cache[0] || (_cache[0] = _createElementVNode("th", { class: "cell-fake" }, null, -1)),
        _createElementVNode("th", _hoisted_2, [
          _createVNode(AppTooltip, null, {
            activator: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("common.rank")), 1)
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(_ctx.$t("common.rankInfo")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("th", _hoisted_3, [
          _createElementVNode("div", {
            textContent: _toDisplayString(_ctx.$t('common.tokenName'))
          }, null, 8, _hoisted_4)
        ]),
        (showCollectionColumn.value)
          ? (_openBlock(), _createElementBlock("th", _hoisted_5, [
              _createVNode(AppTooltip, { end: "" }, {
                activator: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("common.collection")), 1)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.collectionDesc")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("common.price")), 1),
        _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("common.marketCap")), 1),
        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("common.contractAddress")), 1),
        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("common.performance")), 1),
        _cache[1] || (_cache[1] = _createElementVNode("th", { class: "cell-link" }, null, -1))
      ])
    ]),
    (__props.loading && !__props.pages?.length)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (n) => {
            return _createVNode(TokenRowSkeleton, { key: n })
          }), 64))
        ]))
      : (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allItems.value, (token, index) => {
            return (_openBlock(), _createBlock(TokenListTableRow, {
              key: index,
              token: token,
              "show-collection-column": showCollectionColumn.value
            }, null, 8, ["token", "show-collection-column"]))
          }), 128))
        ]))
  ]))
}
}

})